import { render, staticRenderFns } from "./deleteOwner.vue?vue&type=template&id=3e05f4c6"
import script from "./deleteOwner.vue?vue&type=script&lang=js"
export * from "./deleteOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports